/**
 * @generated SignedSource<<f8a514fae6bf20a4dab08216dbcbf9d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEventBody_event$data = {
  readonly __typename: "TodoTimelineUpdateEventAssignedEmployees";
  readonly __typename: "TodoTimelineUpdateEventAssignedEmployees";
  readonly addedAssignedEmployees: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventEmployee_employee">;
  }>;
  readonly removedAssignedEmployees: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventEmployee_employee">;
  }>;
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventAssignedRoles";
  readonly __typename: "TodoTimelineUpdateEventAssignedRoles";
  readonly addedAssignedRoles: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventRole_role">;
  }>;
  readonly removedAssignedRoles: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventRole_role">;
  }>;
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventAssignedTeams";
  readonly __typename: "TodoTimelineUpdateEventAssignedTeams";
  readonly addedAssignedTeams: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventTeam_team">;
  }>;
  readonly removedAssignedTeams: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventTeam_team">;
  }>;
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventBody";
  readonly __typename: "TodoTimelineUpdateEventBody";
  readonly newBody: string;
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventCategory";
  readonly __typename: "TodoTimelineUpdateEventCategory";
  readonly newCategory: {
    readonly title: string;
  };
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventExpireAt";
  readonly __typename: "TodoTimelineUpdateEventExpireAt";
  readonly newExpireAt: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventPriority";
  readonly __typename: "TodoTimelineUpdateEventPriority";
  readonly newPriority: TodoPriority;
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventStatus";
  readonly __typename: "TodoTimelineUpdateEventStatus";
  readonly newStatus: TodoStatus;
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventTags";
  readonly __typename: "TodoTimelineUpdateEventTags";
  readonly addedTodoTags: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventTag_tag">;
  }>;
  readonly removedTodoTags: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventTag_tag">;
  }>;
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventTitle";
  readonly __typename: "TodoTimelineUpdateEventTitle";
  readonly newTitle: string;
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TodoTimelineUpdateEventBody_event";
};
export type TodoTimelineUpdateEventBody_event$key = {
  readonly " $data"?: TodoTimelineUpdateEventBody_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventBody_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "TodoTimelineUpdateEventEmployee_employee"
  }
],
v2 = [
  (v0/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "TodoTimelineUpdateEventTag_tag"
  }
],
v3 = [
  (v0/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "TodoTimelineUpdateEventTeam_team"
  }
],
v4 = [
  (v0/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "TodoTimelineUpdateEventRole_role"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEventBody_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "addedAssignedEmployees",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "removedAssignedEmployees",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventAssignedEmployees",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newTitle",
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventTitle",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newBody",
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventBody",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newStatus",
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventStatus",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newPriority",
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventPriority",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoCategory",
          "kind": "LinkedField",
          "name": "newCategory",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventCategory",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreZonedDate",
          "kind": "LinkedField",
          "name": "newExpireAt",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "StoreFormattedDate"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventExpireAt",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoCategoryTag",
          "kind": "LinkedField",
          "name": "addedTodoTags",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoCategoryTag",
          "kind": "LinkedField",
          "name": "removedTodoTags",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventTags",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "addedAssignedTeams",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "removedAssignedTeams",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventAssignedTeams",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "addedAssignedRoles",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "removedAssignedRoles",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventAssignedRoles",
      "abstractKey": null
    }
  ],
  "type": "TodoTimelineUpdateEvent",
  "abstractKey": "__isTodoTimelineUpdateEvent"
};
})();

(node as any).hash = "ed491f003dd348fd592f2448fab3345d";

export default node;
